__webpack_require__.p = "/reports-pie-chart-preset-2/referrals-hub/";